function Page() {
    document.title = '404';
    return 404
}

export default Page